module.exports = "/_next/static/images/tree-monotone-76dac79ad063ebfae6b32df3ab15c32f.svg";